__webpack_require__.p = "/exercices/exerciseur/math/";